import i18n from '@/helpers/i18n'
import { Consts } from '@/helpers/consts'

export const LivingExpensesPayerList = {
  data() {
    return {
      livingExpensesPayerList: [
        { text: i18n.instance().t('living-expenses-payer-me'), id: Consts.LIVING_EXPENSES_PAYER_ME },
        { text: i18n.instance().t('living-expenses-payer-family-member'), id: Consts.LIVING_EXPENSES_PAYER_FAMILY_MEMBER },
        {
          text: i18n.instance().t('living-expenses-payer-me-and-family-member'),
          id: Consts.LIVING_EXPENSES_PAYER_ME_AND_FAMILY_MEMBER
        },
        { text: i18n.instance().t('living-expenses-scholarship'), id: Consts.LIVING_EXPENSES_SCHOLARSHIP },
        { text: i18n.instance().t('living-expenses-payer-other'), id: Consts.LIVING_EXPENSES_PAYER_OTHER },
        { text: i18n.instance().t('na-options'), id: Consts.LIVING_EXPENSES_PAYER_NA }
      ]
    }
  },
  methods: {
    getLivingExpensesPayerFacetLabel: function(livingExpensesFacet) {
      return `${this.livingExpensesPayerList.filter(x => x.id === livingExpensesFacet.value.toString()).first().text} (${
        livingExpensesFacet.count
      })`
    },
    getLivingExpensesPayerLabelById: function(id) {
      return this.livingExpensesPayerList.filter(x => x.id === id).first().text
    }
  }
}
